/**
 * The content library. The file list comes from the repo `assets` folder
 * at build time; the bytes stay on disk and are served from `/library`.
 */

import { libraryFiles } from 'virtual:craftara-library';
import { libraryAssetFromPath, type LibraryAsset } from './libraryCatalog';

export const LIBRARY_ASSETS: LibraryAsset[] = libraryFiles
  .map((file) => libraryAssetFromPath(file))
  .filter((item): item is LibraryAsset => item !== null);

export function libraryById(id: string): LibraryAsset | null {
  return LIBRARY_ASSETS.find((item) => item.id === id) ?? null;
}
